export default __webpack_public_path__ + "static/media/logo_sedaro_primary_white.75dba01f.png";